<script setup lang="ts">
import { ref, useSlots } from 'vue';
import { useElementSize } from '@vueuse/core';
type Props = {
    archived?: boolean;
    blocked?: boolean;
    disabled?: boolean;
};
const props = defineProps<Props>();

const slots = useSlots();
const hasSlot = (slotName: string) => {
    return !!slots[slotName];
};
const selected = ref(false);

const rightSection = ref();
const { width } = useElementSize(rightSection);
</script>

<template>
    <div
        class="card-layout"
        :class="{
            selected: selected,
            'has-progress': hasSlot('progress'),
            archived: props.archived,
            disabled: props.disabled
        }">
        <div class="card-layout--left-section">
            <slot name="left"> left placeholder </slot>
        </div>
        <div ref="rightSection" class="card-layout--right-section">
            <div class="detailed-information">
                <slot name="detail" :width="width - 180"> right placeholder </slot>
            </div>
            <div class="actions">
                <div class="quick-action">
                    <slot name="quick-action"> </slot>
                </div>
                <div class="more-actions">
                    <slot name="more-actions" :show="() => (selected = true)" :hide="() => (selected = false)"> </slot>
                </div>
            </div>
            <div v-if="hasSlot('status')" class="status">
                <slot name="status"></slot>
            </div>
            <div v-if="hasSlot('progress')" class="progress">
                <slot name="progress"></slot>
            </div>
        </div>
    </div>
</template>
